import { MenuItem } from '@ids/menu';
import DropdownTypeahead from './DropdownTypeahead';

export default DropdownTypeahead;
export { MenuItem };
